import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DataTable from "../components/UI/DataTable/DataTable";
import { CAMPAIGN_TABLE_COLUMNS, MAILING_LIST_TABLE_COLUMNS, MESSAGING_HISTORY_TABLE_COLUMNS } from "../constants/Constants";
import { commonActions } from "../redux/reducers/CommonReducer";
import { TABLES, UTRON_PLARFORMS } from "../enums/Enums";
import { userActions } from "../redux/reducers/UserReducer";
import store from "../redux/Store";
import * as actionsService from "../services/ActionsService/ActionsService";
import * as messagingActionsService from "../services/ActionsService/MessagingActionsService";
import { getCurrentSites, getSitesUnderSelectedScope } from "../utils/UsersUtils";
import MessagingDetails from "../containers/UserInfo/Details/MessagingDetails";
import { messagingActions } from "../redux/reducers/MessagingReducer";
import { showErrorMessage } from "../utils/MessagesUtils";
import { getDeletedRecipientsIds, getMailingListData, getMessagingCampaignsData, getMessagingHistoriesData } from "../utils/MessagingUtils";
import { MessagingCostEntity } from "../entities/ServicesEntities/MessagingEntities/MessagingCostEntity";
import { removeDuplicatesInArray } from "../utils/CommonUtils";

const useMessagingService = () => {
  const currentUsersScopes = useSelector((state) => state.user.currentUsersScopes);

  // const currentUsersSite = useSelector((state) => state.user.currentUsersSite);
  // const currentGmtUsers = useSelector((state) => state.user.currentGmtUsers);
  // const currentChargeAccounts = useSelector((state) => state.user.currentChargeAccounts);

  const allScopes = useSelector((state) => state.user?.allScopes);
  const sites = useSelector((state) => state.user.sites);
  const selectedScope = useSelector((state) =>  state.user?.selectedScope); // added
  const selectedSites = getSitesUnderSelectedScope(sites, allScopes, selectedScope);

  const campaignColumns = CAMPAIGN_TABLE_COLUMNS;
  const messagingHistoryColumns = MESSAGING_HISTORY_TABLE_COLUMNS;
  const mailingListsColumns = MAILING_LIST_TABLE_COLUMNS;

  const campaignsData = useSelector((state) => state.messaging.campaignsData);
  const mailingListsData = useSelector((state) => state.messaging.mailingListsData);
  const messagingHistoriesData = useSelector((state) => state.messaging.messagingHistoriesData);

  const isFirstTimeLoading = useSelector((state) => state.common.isFirstTimeLoading);
  const [inProcess, setInProcess] = useState(false);

  //Set all tables data
  useEffect(() => {
    //let currentSelectedScopes = [];
    //currentSelectedScopes.push(selectedScope);

    let currentSites = getCurrentSites(sites, currentUsersScopes); // prev
    //let currentSites = getCurrentSites(sites, currentSelectedScopes); // test
    const ids = [];
    let allIds = [];
    currentSites.forEach((site) => {
      site?.userSites.forEach((userSite) => {
        if (userSite.userId && !ids.some((id) => id === userSite.userId)) {
          ids.push(userSite.userId);
        }
        site?.tokens.forEach((token) => {
          token.carUserTokens?.forEach((carUserToken) => {
            if (carUserToken.userId && !ids.some((id) => id === carUserToken.userId)) {
              ids.push(carUserToken.userId);
            }
          });
        });
      });
    });
    if (ids.length > 0) {
      //Get Users Identity
      if (!inProcess) {
        setInProcess(true);
        let scopesIds = currentUsersScopes.map(userScope => userScope.id);
        const currentScope = selectedScope?.id; // const currentScope = selectedSite?.scopeId;
        const gmtType = UTRON_PLARFORMS.GMT;

        // gets customers for messaging (parkers) - check if already exists on reducer
        // if data already exists take currentUsersSite as the currentScopeUsers data, and save additional call
        // if (currentUsersSite?.length > 0) {
        //     store.dispatch(messagingActions.setCurrentScopeUsers(currentUsersSite));
        // }
        // else {
        //   // get data
        //   actionsService.getUsersIdentityData(ids, scopesIds, isFirstTimeLoading, !isFirstTimeLoading)
        //   .then((response) => {
        //     store.dispatch(messagingActions.setCurrentScopeUsers(response.data.entity));

        //     // when not on first time - controles the row click loading spinner
        //     //store.dispatch(commonActions.setIsFirstTimeLoading(false)); // false
  
        //     // setInProcess(false);
        //     // if (selectedScope /*&& isFirstTimeLoading*/) {
        //     //   store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        //     // }
        //   });  
        // }

        // currently cannot rely on currentUsersSites from previous actions 
        // - example on edit user then moving to Messaging page,
        // - see userReducer, setUsersScope , currentUsers, utronUser is removed
        // get data
        actionsService.getUsersIdentityData(ids, scopesIds, isFirstTimeLoading, !isFirstTimeLoading)
        .then((response) => {
          store.dispatch(messagingActions.setCurrentScopeUsers(response.data.entity));

          // when not on first time - controles the row click loading spinner
          //store.dispatch(commonActions.setIsFirstTimeLoading(false)); // false

          // setInProcess(false);
          // if (selectedScope /*&& isFirstTimeLoading*/) {
          //   store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          // }
        });  
    
        //get gmt users
        actionsService.getGmtUsers(gmtType, currentScope, isFirstTimeLoading, false).then((response) => {
          if (response.data.isSuccess) {
            // charge accounts (?)
            let currentGmtUsers = response.data.entity.filter(user => user.userScopes.some(us => us.role.name !== "Charge Account"));
            store.dispatch(userActions.setCurrentGmtUsers(currentGmtUsers));
            
            // concat gmt users ids to ids with distinct, for further check
            allIds = removeDuplicatesInArray(ids.concat(currentGmtUsers.map(u => u.utronUser.id)));

            // gets charge accounts
            // let chargeAccounts = response.data.entity.filter(user => user.userScopes.some(us => us.role.name === "Charge Account"));
            // let chargeAccountsIds = response.data.entity.filter(user => user.userScopes.some(us => us.role.name === "Charge Account")).map(user => user.utronUser.id);
  
            // actionsService.getChargeAccountsData(chargeAccountsIds, true, true)
            // .then(response => {
            //   let currentChargeAccounts = getChargeAccountsData(chargeAccounts, response.data.entity);
            //   store.dispatch(userActions.setCurrentChargeAccounts(currentChargeAccounts));
            // })
            // .catch(error => {
            //   console.log(error);
            // });

            // get campaigns
            let campaignsData = {};
            messagingActionsService.getCampaignsBySiteId(selectedSites?.[0]?.id, isFirstTimeLoading, false)
            .then((response => {
              if (response.data.isSuccess) {
                campaignsData = getMessagingCampaignsData(response.data.entity, selectedSites?.[0]);
                store.dispatch(messagingActions.setCampaignsData(campaignsData));

                // get messaging histories by campaigns ids
                let allCampaignsIds = campaignsData?.campaigns.concat(campaignsData?.deletedCampaigns)?.map(c => c.id);
                messagingActionsService.getMessagingHistoriesByCampaignsIds(allCampaignsIds, isFirstTimeLoading, false)
                .then((response => {
                  if (response.data.isSuccess) {
                    let allCampaigns = campaignsData?.campaigns.concat(campaignsData?.deletedCampaigns);

                    // get deleted recipients ids
                    const deletedRecipientsIds = getDeletedRecipientsIds(allIds, response.data.entity);           
                    let messagingHistoriesData = getMessagingHistoriesData(response.data.entity, allCampaigns, deletedRecipientsIds, selectedSites?.[0]);

                    store.dispatch(messagingActions.setMessagingHistoriesData(messagingHistoriesData));
                    let messagingHistoryIds = messagingHistoriesData?.messagingHistories?.map(mh => mh.id);
                    
                    // this is the closing spinner call
                    messagingActionsService.getMessagingHistoryToMailingListsByMessagingHistoryIds(messagingHistoryIds, isFirstTimeLoading, true)
                    .then((response => {
                      if (response.data.isSuccess) {
                        store.dispatch(messagingActions.setMessagingHistoryToMailingLists(response.data.entity));
                      }
                      else {
                        showErrorMessage(response.data?.error);
                        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
                      }
                    }))
                    .catch(error => {
                      showErrorMessage(error);
                      store.dispatch(commonActions.setIsShowLoadingSpinner(false));
                    });
                  }
                  else {
                    showErrorMessage(response.data?.error);
                    store.dispatch(commonActions.setIsShowLoadingSpinner(false));
                  }
                }))
                .catch(error => {
                  showErrorMessage(error);
                  store.dispatch(commonActions.setIsShowLoadingSpinner(false));
                });
              }
              else {
                showErrorMessage(response.data?.error);
                store.dispatch(commonActions.setIsShowLoadingSpinner(false));
              }
            })).catch(error => {
              showErrorMessage(error);
              store.dispatch(commonActions.setIsShowLoadingSpinner(false));
            });
  
            setInProcess(false);
          }
          store.dispatch(commonActions.setIsFirstTimeLoading(false));
        });

        messagingActionsService.getMailingListsBySiteId(selectedSites?.[0]?.id, isFirstTimeLoading, false)
        .then((response => {
          if (response.data.isSuccess) {
            let mailingListsData = getMailingListData(response.data.entity, selectedSites?.[0]);
            store.dispatch(messagingActions.setMailingListsData(mailingListsData));
          }
          else {
            showErrorMessage(response.data?.error);
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          }
        })).catch(error => {
          showErrorMessage(error);
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        });

        messagingActionsService.getMessagingCostsBySiteId(selectedSites?.[0]?.id, isFirstTimeLoading, false)
        .then((response => {
          if (response.data.isSuccess) {
            if (response.data.entity?.length > 0) {
              store.dispatch(messagingActions.setMessagingCostsData(response.data.entity?.[0]));
            }
            else {
              // if not founded set default messaging cost
              store.dispatch(messagingActions.setMessagingCostsData(new MessagingCostEntity(0, 0, 0, selectedSites?.[0]?.id)));
            }
          }
          else {
            showErrorMessage(response.data?.error);
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          }
        })).catch(error => {
          showErrorMessage(error);
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        });
      };
         
    } else {
      store.dispatch(userActions.resetTablesData());
      if ((currentSites && currentSites.length !== 0) || (sites.length > 0 && selectedScope !== null)) {
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      }
    }
  }, [sites, currentUsersScopes]);

  const getCampaignDataTable = (eventFn) => {
    return ( selectedScope && 
      <DataTable
        onRowClick={eventFn}
        columns={campaignColumns}
        rows={campaignsData?.campaigns} 
        tableId={TABLES.CAMPAIGNS}
        selectedScope={selectedScope}
        minDate={campaignsData?.minDate}
        maxDate={campaignsData?.maxDate}
      ></DataTable>
    );
  };

  const getMessagingHistoryTable = (eventFn) => {
    return (
      <DataTable
        onRowClick={eventFn}
        columns={messagingHistoryColumns}
        rows={messagingHistoriesData?.messagingHistories} 
        tableId={TABLES.MESSAGING_HISTORY}
        selectedScope={selectedScope}
        minDate={messagingHistoriesData?.minDate}
        maxDate={messagingHistoriesData?.maxDate}
      ></DataTable>
    );
  };

  const getMailingListsTable = (eventFn) => {
    return (
      <DataTable
        onRowClick={eventFn}
        columns={mailingListsColumns}
        rows={mailingListsData?.mailingLists} 
        tableId={TABLES.MAILING_LIST} 
        selectedScope={selectedScope}
        minDate={mailingListsData?.minDate}
        maxDate={mailingListsData?.maxDate}
      ></DataTable>
    );
  };

  const getMessagingDetails = (props) => {
    return <MessagingDetails {...props}></MessagingDetails>;
  };

  return {
    getCampaignDataTable,
    getMessagingHistoryTable,
    getMailingListsTable,
    getMessagingDetails
  };
};

export default useMessagingService;
